import { actionTypes } from '../index';

export const setPrevStep = (stepIndex: number) => ({
    type: actionTypes.SET_PREV_STEP,
    payload: stepIndex,
});
